"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _Text = _interopRequireWildcard(require("@kiwicom/orbit-components/lib/Text"));
var _Illustration2 = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Illustration"));
var _ModalSection = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalSection"));
var _ModalHeader = _interopRequireDefault(require("@kiwicom/orbit-components/lib/Modal/ModalHeader"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _jsxRuntime = require("react/jsx-runtime");
var _FormattedMessage, _FormattedMessage2, _Illustration, _FormattedMessage3;
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const TextWrapper = /*#__PURE__*/(0, _styledComponents.default)(_Text.StyledText).withConfig({
  displayName: "CheckEmail__TextWrapper",
  componentId: "sc-18lpx7m-0"
})(["overflow-wrap:break-word;"]);
const CheckEmail = ({
  email,
  reason
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalHeader.default, {
      title: reason === "signUpConfirmation" ? _FormattedMessage || (_FormattedMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.sign_up_confirmation.title"
      })) : _FormattedMessage2 || (_FormattedMessage2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
        id: "account.check_email"
      })),
      illustration: _Illustration || (_Illustration = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Illustration2.default, {
        name: "Mailbox",
        size: "small"
      }))
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ModalSection.default, {
      dataTest: "MagicLogin-CheckEmail",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Text.default, {
        children: [reason === "magicLink" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.check_email_magic_link",
          values: {
            email,
            ref: text => /*#__PURE__*/(0, _jsxRuntime.jsx)(TextWrapper, {
              as: "span",
              weight: "bold",
              children: text
            })
          }
        }), reason === "signUpConfirmation" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.sign_up_confirmation.description",
          values: {
            email,
            ref: text => /*#__PURE__*/(0, _jsxRuntime.jsx)(TextWrapper, {
              as: "span",
              weight: "bold",
              children: text
            })
          }
        }), reason === "resetPassword" && (_FormattedMessage3 || (_FormattedMessage3 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIntl.FormattedMessage, {
          id: "account.you_will_recieve_password"
        })))]
      })
    })]
  });
};
var _default = CheckEmail;
exports.default = _default;